import { SET_PREP_TEST_SCORES } from "../actions/types"
import type { SetPrepTestScoresAction } from "../actions/prepActions"
import type { PrepTestQuestionScores } from "../components/prep/PrepTestQuiz"

interface CourseScore {
  [courseId: string]: { [chapterId: string]: PrepTestQuestionScores }
}

interface PrepState {
  courseScores: CourseScore
}

const INITIAL_STATE: PrepState = {
  courseScores: {},
}

type Actions = SetPrepTestScoresAction

export default (state = INITIAL_STATE, action: Actions): PrepState => {
  switch (action.type) {
    case SET_PREP_TEST_SCORES: {
      const {
        payload: { chapterId, courseId, scores },
      } = action
      return {
        ...state,
        courseScores: {
          ...state.courseScores,
          [courseId]: {
            ...state.courseScores?.[courseId],
            [chapterId]: {
              ...state.courseScores?.[courseId]?.[chapterId],
              ...scores,
            },
          },
        },
      }
    }
    default:
      return state
  }
}
